/* ==========================================================================
   MÓDULO: POSTS RELACIONADOS
   Encuentra y muestra artículos con etiquetas compartidas.
   ========================================================================== */

// Función para crear el HTML de una tarjeta de post relacionado
function createPostCardHTML(post) {
  return `
    <article class="card card--related">
          ${post.category ? `<p class="rubric">${post.category}</p>` : ""}
          <h4 class="card__title"><a href="${post.url}">${post.title}</a></h4>
          <p class="card__description">${post.description}</p>
          <a href="${post.url}" class="card__more">Leer más</a>
        </article>
      `;
}

// Función principal asíncrona
async function initRelatedPosts() {
  const container = document.getElementById("related-posts-container");
  if (!container) return;

  // 1. Obtenemos los datos del post actual desde los atributos data-*
  const currentPostUrl = container.dataset.currentPostUrl;
  const currentPostTags = container.dataset.currentPostTags
    .split(",")
    .filter(Boolean);

  if (currentPostTags.length === 0) return;

  try {
    // 2. Cargamos el archivo JSON con todos los posts
    const response = await fetch("/posts.json");
    if (!response.ok) throw new Error("Network response was not ok");
    const allPosts = await response.json();

    // 3. Calculamos la relevancia de cada post
    const relatedPosts = allPosts
      // Excluimos el post actual
      .filter((post) => post.url !== currentPostUrl)
      // Calculamos el "score" de relevancia
      .map((post) => {
        const sharedTags = post.tags.filter((tag) =>
          currentPostTags.includes(tag),
        );
        return {
          ...post,
          relevance: sharedTags.length,
        };
      })
      // Filtramos los que no tienen ninguna etiqueta en común
      .filter((post) => post.relevance > 0)
      // Ordenamos por relevancia (y luego por URL como desempate)
      .sort((a, b) => b.relevance - a.relevance || a.url.localeCompare(b.url));

    // 4. Tomamos los 2 más relevantes y generamos el HTML
    const topRelated = relatedPosts.slice(0, 2);
    if (topRelated.length > 0) {
      const postsHTML = topRelated.map(createPostCardHTML).join("");
      // Creamos un contenedor de rejilla y lo inyectamos
      const gridContainer = document.createElement("div");
      gridContainer.className = "related-posts-grid";
      gridContainer.innerHTML = postsHTML;
      container.appendChild(gridContainer);
    }
  } catch (error) {
    console.error("Error al cargar o procesar los posts relacionados:", error);
  }
}

export default initRelatedPosts;
